export default {"src":"/_next/static/media/like-grey.10406a28.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};